import { Card, Center, Image, Stack, Text, Title } from '@mantine/core';
import { ReactElement } from 'react';
import everselfLogo from '../assets/everself_logo_black.png';

export function MaintenancePage(): ReactElement {
  return (
    <Center h="100vh" bg="#FAFAF5">
      <Card bg="white" p="xl" maw={520} w="100%" shadow="sm" withBorder>
        <Stack gap="lg">
          <Image src={everselfLogo} alt="Everself" w={120} fit="contain" />

          <Title order={3} fw={600}>
            Orbit is Under Maintenance
          </Title>

          <Stack gap="md">
            <Text size="sm">
              Orbit is currently unavailable due to{' '}
              <Text span fw={700}>
                scheduled maintenance
              </Text>
              .
            </Text>
            <Text size="sm">
              To protect system integrity, access is{' '}
              <Text span fw={700}>
                temporarily disabled
              </Text>
              .
            </Text>
            <Text size="sm">
              For urgent clinical matters or immediate support,{' '}
              <Text span fw={700}>
                please contact support
              </Text>
              .
            </Text>
          </Stack>
        </Stack>
      </Card>
    </Center>
  );
}
